<template>
  <q-page padding>
    <div style="align-items: center" class="row col-12">
      <p class="text-h6 text-brand-1 text-weight-bold">Logs do Sistema</p>
      <p class="q-ml-sm text-brand-5">
        <span class="q-ml-sm">-</span> tentativas de acesso e alterações de
        informações, e
        <a class="button-link" @click.prevent="routeNotificacao"
          >clique aqui para log de notificações</a
        >
      </p>
    </div>
    <div class="row text-brand-5 text-weight-bold q-mt-md">
      <div class="q-ml-sm col-md-2">
        Linhas por Pagina:
        <q-input
          class="input-new-design"
          v-model="filtros.perPage"
          dense
          outlined
          type="number"
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Ação:
        <q-select
          v-model="filtros.acao"
          option-label="clienteId"
          :options="listaAcao"
          class="input-new-design"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Recurso ID:
        <q-input
          type="number"
          v-model="filtros.resource_id"
          min="0"
          class="input-new-design"
          dense
          outlined
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="q-ml-sm col-md-3">
        Recurso Nome:
        <q-input
          class="input-new-design"
          v-model="filtros.resource_name"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Status:
        <q-select
          v-model="filtros.level"
          option-label="clienteId"
          :options="listaLevel"
          dense
          class="input-new-design"
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2 q-mt-sm">
        Usuario Id:
        <q-input
          class="input-new-design"
          v-model="filtros.user_id"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2 q-mt-sm">
        Usuario Nome:
        <q-input
          class="input-new-design"
          v-model="filtros.user_name"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2 q-mt-sm">
        Data Inicial:
        <q-input
          v-model="filtros.data_inicial"
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.data_inicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="q-ml-sm col-md-3 q-mt-sm">
        Data Final:
        <q-input
          v-model="filtros.data_final"
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.data_final"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
    </div>

    <div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        class="tabela-tamanho-fixo q-mt-md"
        :rows-per-page-options="[0]"
        hide-pagination
        row-key="name"
      >
        <template v-slot:top-right>
          <!--<q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter"
            placeholder="Filtrar por nome"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>-->
        </template>
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todos os Logs: {{ logsQuantidade }}</span
          >
        </template>
        <template #body-cell-content="props">
          <q-td style="white-space: normal">
            <p style="max-width: 600px; overflow: hidden">
              <!--{{ props.row.content }}-->
              <q-btn
                label="Vizualizar Log"
                outline
                no-caps
                flat
                icon="visibility"
                @click="(verLog = true), (log = props.row.content)"
              />
            </p>
          </q-td>
        </template>
        <template #body-cell-updated_at="props">
          <q-td>
            <div>
              {{
                props.row.updated_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </div>
            <div class="q-pl-sm">
              {{ props.row.updated_at.split(" ")[1] }}
            </div>
          </q-td>
        </template>
      </q-table>
    </div>

    <!-- Dashboard do Kibana - Apenas para staging-multpex -->
    <div class="q-mt-xl" v-if="isKibanaVisible">
      <div class="row col-12 q-mb-md items-center justify-between">
        <p class="text-h6 text-brand-1 text-weight-bold">
          Dashboard Kibana - Análise de Logs
        </p>
        <q-btn
          color="primary"
          icon="open_in_new"
          label="Abrir em Nova Aba"
          @click="openKibanaInNewTab"
          outline
          no-caps
        />
      </div>

      <!-- Filtros do Kibana -->
      <div class="row q-mb-md q-gutter-sm">
        <div class="col-md-3">
          <q-input
            v-model="kibanaFiltros.tenant"
            label="Tenant"
            outlined
            dense
            class="input-new-design"
            placeholder="Digite o tenant..."
          />
        </div>
        <div class="col-md-3">
          <q-input
            v-model="kibanaFiltros.diasAtras"
            label="Dias Atrás"
            outlined
            dense
            class="input-new-design"
            type="number"
            min="1"
            max="365"
            placeholder="Ex: 7 (últimos 7 dias)"
            hint="Número de dias atrás para buscar logs"
          />
        </div>
        <div class="col-md-2">
          <q-btn
            color="primary"
            icon="filter_alt"
            label="Aplicar Filtros"
            @click="aplicarFiltrosKibana"
            no-caps
            class="full-width"
          />
        </div>
        <div class="col-md-1">
          <q-btn
            color="grey"
            icon="clear"
            label="Limpar"
            @click="limparFiltrosKibana"
            outline
            no-caps
            class="full-width"
          />
        </div>
      </div>

      <div class="kibana-container" v-if="!kibanaError">
        <iframe
          ref="kibanaIframe"
          :src="kibanaUrl"
          width="100%"
          height="800"
          frameborder="0"
          class="kibana-iframe"
          title="Dashboard Kibana - Logs do Sistema"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          @error="handleKibanaError"
          :key="kibanaKey"
        ></iframe>
      </div>
      <div v-else class="kibana-error-container">
        <q-card class="q-pa-lg text-center">
          <q-card-section>
            <q-icon name="warning" size="3rem" color="orange" />
            <h5 class="q-mt-md q-mb-md">Dashboard não pôde ser carregado</h5>
            <p class="text-grey-7">
              O dashboard do Kibana não pôde ser carregado devido a restrições
              de segurança. Clique no botão abaixo para acessá-lo em uma nova
              aba.
            </p>
            <q-btn
              color="primary"
              icon="open_in_new"
              label="Abrir Kibana em Nova Aba"
              @click="openKibanaInNewTab"
              class="q-mt-md"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>

    <q-dialog v-model="verLog">
      <q-card>
        <q-card-section> </q-card-section>

        <q-card-section class="q-pt-none">
          <vue-json-pretty :data="log" />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "action",
    label: "Ação",
    field: "action",
    align: "left",
  },
  {
    name: "level",
    label: "Status",
    field: "level",
    align: "left",
  },
  {
    name: "resource_name",
    label: "Recurso",
    field: "resource_name",
    align: "left",
  },
  {
    name: "user_name",
    label: "Usuário",
    align: "left",
    field: "user_name",
  },
  {
    name: "user_id",
    label: "ID Usuário",
    field: "user_id",
    align: "left",
  },
  {
    name: "content",
    label: "Conteúdo",
    field: "content",
    align: "left",
  },
  {
    name: "updated_at",
    label: "Data",
    field: "updated_at",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { watchDebounced } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import ClienteIdentificadorService from "@/helpers/clienteIdentificadorService";
export default {
  components: { VueJsonPretty },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const router = useRouter();
    const disable = ref(true);
    const filter = ref("");
    const verLog = ref(false);
    const log = ref(null);
    const logsQuantidade = ref(0);
    const kibanaError = ref(false);
    const kibanaKey = ref(0);
    const kibanaFiltros = ref({
      tenant: "",
      diasAtras: 8,
    });
    const filtros = ref({
      perPage: 15,
      acao: "Todos",
      resource_id: "",
      resource_name: "",
      level: "",
      user_id: "",
      user_name: "",
      data_inicial: "",
      data_final: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("configuracao/getLogs", {
          page: page,
          per_page: rowsPerPage,
          action:
            filtros.value.acao == "Todos" ? undefined : filtros.value.acao,
          resource_id:
            filtros.value.resource_id == ""
              ? undefined
              : filtros.value.resource_id,
          resource_name:
            filtros.value.resource_name == ""
              ? undefined
              : filtros.value.resource_name,
          level: filtros.value.level == "" ? undefined : filtros.value.level,
          user_id:
            filtros.value.user_id == "" ? undefined : filtros.value.user_id,
          user_name:
            filtros.value.user_name == "" ? undefined : filtros.value.user_name,
          data_inicial:
            filtros.value.data_inicial == ""
              ? undefined
              : filtros.value.data_inicial,
          data_final:
            filtros.value.data_final == ""
              ? undefined
              : filtros.value.data_final,
        });

        rows.value = response.data.results.data;

        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        logsQuantidade.value = response.data.results.total;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const routeNotificacao = async () => {
      router.push({
        name: "configuracao-logs-lista-notificacao",
      });
    };

    // Função para construir URL do Kibana com filtros
    const construirUrlKibana = () => {
      const baseUrl =
        "https://kibana.devops.multpex.com.br/app/dashboards#/view/9b8dfe04-10ac-487c-a1ca-c7246fe0940b";

      console.log("🚀 INICIANDO construção da URL Kibana");
      console.log("📝 Valores dos filtros recebidos:", kibanaFiltros.value);

      // Construir o parâmetro _g (global state)
      let globalParams = {
        filters: "!()",
        refreshInterval: "(pause:!t,value:60000)",
      };

      // Filtro de tempo no _g usando formato "now-Xd"
      const diasAtras = kibanaFiltros.value.diasAtras || 8;
      globalParams.time = `(from:now-${diasAtras}d,to:now)`;

      console.log("✅ Usando filtro de tempo:", globalParams.time);

      // Construir query do tenant no _a
      let query = "";
      if (
        kibanaFiltros.value.tenant &&
        kibanaFiltros.value.tenant.trim() !== ""
      ) {
        console.log(
          "✅ Adicionando filtro de tenant na query:",
          kibanaFiltros.value.tenant.trim()
        );
        query = `tenant:"${kibanaFiltros.value.tenant.trim()}"`;
      }

      // Montar os parâmetros _g
      const gParam = `(filters:${globalParams.filters},refreshInterval:${globalParams.refreshInterval},time:${globalParams.time})`;

      // Montar os parâmetros _a
      const aParam = `(query:(language:kuery,query:'${query}'))`;

      const finalUrl = `${baseUrl}?_g=${gParam}&_a=${aParam}`;

      // Log da URL final para validação
      console.log("� Parâmetros _g:", gParam);
      console.log("🔧 Parâmetros _a:", aParam);
      console.log("🔍 URL Kibana Final COMPLETA:", finalUrl);
      console.log("📊 Resumo dos filtros aplicados:", {
        tenant: kibanaFiltros.value.tenant,
        diasAtras: kibanaFiltros.value.diasAtras,
        query: query,
      });

      return finalUrl;
    };

    // URL reativa do Kibana
    const kibanaUrl = computed(() => {
      return construirUrlKibana();
    });

    const openKibanaInNewTab = () => {
      window.open(kibanaUrl.value, "_blank");
    };

    const handleKibanaError = () => {
      kibanaError.value = true;
      console.warn("Kibana iframe failed to load due to CSP restrictions");
    };

    const aplicarFiltrosKibana = () => {
      // Força o recarregamento do iframe
      kibanaKey.value += 1;
      kibanaError.value = false;

      console.log("Aplicando filtros Kibana:", kibanaFiltros.value);
      console.log("Nova URL:", kibanaUrl.value);
    };

    const limparFiltrosKibana = () => {
      kibanaFiltros.value.tenant = "";
      kibanaFiltros.value.diasAtras = 8;
      aplicarFiltrosKibana();
    };

    // Computed para verificar se deve mostrar o Kibana
    const isKibanaVisible = computed(() => {
      const clienteTenant = ClienteIdentificadorService.cliente();

      return clienteTenant === "staging-multpex";
    });

    watchDebounced(
      [
        () => filtros.value.perPage,
        () => filtros.value.acao,
        () => filtros.value.resource_id,
        () => filtros.value.resource_name,
        () => filtros.value.level,
        () => filtros.value.user_id,
        () => filtros.value.user_name,
        () => filtros.value.data_final,
        () => filtros.value.data_inicial,
      ],
      () => {
        if (
          filtros.value.data_inicial != "" &&
          filtros.value.data_inicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.data_final != "" &&
          filtros.value.data_final.length != 10
        ) {
          return;
        }
        getDados(pagination.value.page, +filtros.value.perPage);
      },
      { debounce: 400 }
    );

    watchDebounced(
      () => filter.value,
      () => {
        getDados();
      },
      { debounce: 400 }
    );

    return {
      rows,
      columns,
      getDados,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      logsQuantidade,
      routeNotificacao,
      openKibanaInNewTab,
      handleKibanaError,
      kibanaError,
      kibanaFiltros,
      kibanaUrl,
      kibanaKey,
      aplicarFiltrosKibana,
      limparFiltrosKibana,
      isKibanaVisible,
      verLog,
      log,
      filtros,
      filter: ref(""),
      listaAcao: ["Todos", "Login", "Insert", "Update", "Delete"],
      listaLevel: ["Info", "Error"],
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button-link {
  cursor: pointer;
  color: #0000ff;
  text-decoration: underline;
}

.kibana-container {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.kibana-error-container {
  width: 100%;
}

.kibana-iframe {
  display: block;
  border: none;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .kibana-iframe {
    height: 600px;
  }
}

@media (max-width: 480px) {
  .kibana-iframe {
    height: 500px;
  }
}
</style>
